<script>
import RawData from "@/components/widgets/raw-data.vue";
import { groupBy } from 'lodash';
import Swal from "sweetalert2";

export default {
    components: {
        RawData
    },
    props: {
        department: Boolean,
        opcrType: {
            type: String,
            default: 'planning'
        },
        proposal: Boolean,
        selectedTransfer: Object,
        selectedOPCR: Object,
        startTranferApiToOPCR: Boolean,
        itemList: Array,
        opcrs: Array,
        targetData: Array,
        loadOpcrs: Boolean,
        selectAllAPI: Boolean,
        tableBusy: Boolean,
        startSelection: Boolean,
        apiName: String,
        loadItems: Boolean,
        selectedTarget: Object,
        selectedItem: [Number, String],
        selectedTemplate: null,
    },
    data() {
        return {
            searchOPCR: '',
            pageOptions: [5, 10, 25, 50, 100],
            perPage: 5,
            perPageItem: 1,
            totalRows: 1,
            currentPage: 1,
            currentPageItem: 1,
            filter: null,
            showTarget: false,
            showOPCR: false,
            filterOn: ['name'],
            sortBy: "name",
            sortDesc: false,
            filterIndicatorItem: "",
            isNGO: window.IS_SCHOOL ? false : true,
            exportLoading: false,
            sideWidth: 350,
            collapsedNodes: {}
        }
    },
    computed: {
        returnFields() {
            if (this.opcrType === 'planning') {
                let data = [
                    {
                        key: "name",
                        label: "Activity Program Initiative Name",
                        sortable: true,
                    },
                    {
                        key: "totalResources",
                        sortable: true,
                        label: "Total Resources",
                        thStyle: { width: "200px" },
                    },
                    {
                        key: "actions",
                        thStyle: { width: "90px" },
                    },
                ]
                if (this.proposal) {
                    data.splice(1, 0, {
                        key: "status",
                        sortable: true,
                        label: "Status",
                        thStyle: { width: "150px" },
                    });
                }
                return data;
            } else {
                return [
                    {
                        key: "name",
                        label: "API Name",
                        sortable: true,
                    },
                    {
                        key: "totalCurrency",
                        sortable: true,
                        label: "Total Resources",
                        thStyle: { width: "180px" },
                    },
                    {
                        key: "score",
                        sortable: true,
                        thStyle: { width: "150px" },
                    },

                    {
                        key: "status",
                        sortable: true,
                        thStyle: { width: "200px" },
                    },
                    {
                        key: "actions",
                        thStyle: { width: "90px" },
                    },
                ]
            }
        },
        canCreateOPCR() {
            if (this.opcrType === 'planning' && !this.startTranferApiToOPCR && this.selectedTransfer && !this.selectedTransfer.id && !this.proposal) {
                return true;
            }
            if (this.proposal && this.selectedTemplate && this.selectedTemplate.id) {
                return true;
            }
            return false;
        },
        rows() {
            if (this.filter) {
                return this.totalRows;
            }
            return this.targetData.length;
        },
        filteredOPCRs() {
            let data = this.opcrs;
            if (this.searchOPCR.trim() != "" && this.searchOPCR) {
                data = data.filter((item) => {
                    return item.title
                        .toUpperCase()
                        .includes(this.searchOPCR.toUpperCase());
                });
            }
            return data;
        },
        filteredApis() {
            let data = this.targetData;
            if (this.filter && this.filter.trim() != "") {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            var groupedClass = groupBy(data, "type");
            var classID = 1;
            var grouped = [];
            for (const cKey in groupedClass) {
                let groupedPrexc = groupBy(groupedClass[cKey], 'prexcId');
                var classGrp = [];
                for (const pKey in groupedPrexc) {
                    let cInd = groupedPrexc[pKey];
                    let grpInd = groupBy(cInd, 'indicatorId')
                    var prexcGrp = []
                    for (const iKey in grpInd) {
                        let groupedIndItem = groupBy(grpInd[iKey], 'indicatorItemId')
                        var indGrp = []
                        for (const iiKey in groupedIndItem) {
                            indGrp.push({
                                id: iiKey,
                                indicatorItem: groupedIndItem[iiKey][0].indicatorItem,
                                data: groupedIndItem[iiKey],
                            })
                        }
                        prexcGrp.push({
                            id: iKey,
                            indicator: grpInd[iKey][0].indicator,
                            data: indGrp,
                        })
                    }
                    classGrp.push({
                        id: pKey,
                        prexc: groupedPrexc[pKey][0].prexc,
                        data: prexcGrp,
                    })
                }
                grouped.push({
                    id: classID++,
                    data: classGrp,
                    key: cKey,
                });
            }
            return grouped;
        },
        filteredItems() {
            let data = this.itemList;
            if (this.filterIndicatorItem.trim() != "" && this.filterIndicatorItem) {
                data = data.filter((item) => {
                    return item.searchList
                        .toUpperCase()
                        .includes(this.filterIndicatorItem.toUpperCase());
                });
            }
            var grouped = [];
            if (this.opcrType === 'planning') {
                var groupedClass = groupBy(data, "classification");
                var classID = 1;
                for (const cKey in groupedClass) {
                    let groupedPrexc = groupBy(groupedClass[cKey], 'prexcId');
                    var classGrp = [];
                    for (const pKey in groupedPrexc) {
                        let cInd = groupedPrexc[pKey];
                        let grpInd = groupBy(cInd, 'indicatorId')
                        var prexcGrp = []
                        for (const iKey in grpInd) {
                            let groupedIndItem = groupBy(grpInd[iKey], 'indicatorItemId')
                            var indGrp = []
                            for (const iiKey in groupedIndItem) {
                                indGrp.push({
                                    id: iiKey,
                                    indicatorItem: groupedIndItem[iiKey][0].indicatorItem,
                                    data: groupedIndItem[iiKey],
                                })
                            }
                            prexcGrp.push({
                                id: iKey,
                                indicator: grpInd[iKey][0].indicator,
                                data: indGrp,
                            })
                        }
                        classGrp.push({
                            id: pKey,
                            prexc: groupedPrexc[pKey][0].prexc,
                            data: prexcGrp,
                        })
                    }
                    grouped.push({
                        id: classID++,
                        data: classGrp,
                        key: cKey,
                    });
                }
                return grouped;
            } else {
                var groupedPrexC = groupBy(data, "prexC");
                var PrexcID = 1;
                var iiID = 1;
                for (const key in groupedPrexC) {
                    var group = groupBy(groupedPrexC[key], "indicatorItem");
                    var FC = [];
                    for (const y in group) {
                        FC.push({
                            id: iiID++,
                            data: group[y],
                            key: y,
                        });
                    }
                    grouped.push({
                        id: PrexcID++,
                        data: FC,
                        key: key,
                    });
                }
                var total = this.currentPageItem * this.perPageItem;
                var currentData = grouped.slice(total - this.perPageItem, total);
                return currentData;
            }
        },
        rowsItems() {
            let data = this.itemList;
            if (this.filterIndicatorItem.trim() != "" && this.filterIndicatorItem) {
                data = data.filter((item) => {
                    return item.searchList
                        .toUpperCase()
                        .includes(this.filterIndicatorItem.toUpperCase());
                });
            }
            var groupedPrexC = groupBy(data, "prexC");
            var PrexcID = 1;
            var iiID = 1;
            var grouped = [];
            for (const key in groupedPrexC) {
                var group = groupBy(groupedPrexC[key], "indicatorItem");
                var FC = [];
                for (const y in group) {
                    FC.push({
                        id: iiID++,
                        data: group[y],
                        key: y,
                    });
                }
                grouped.push({
                    id: PrexcID++,
                    data: FC,
                    key: key,
                });
            }
            return grouped.length;
        },

        selectedApiComputed() {
            if (this.selectAllAPI) {
                let data = [];
                this.targetData.map(item => {
                    item.planningApis.map(x => {
                        if (x.selected) {
                            data.push(x);
                        }
                    })
                })
                return data;
            } else {
                return this.targetData.filter((item) => {
                    return item.selected;
                });
            }
        },
        checkAll: {
            get() {
                if (this.selectAllAPI) {
                    return this.targetData.every((item) => {
                        return item.planningApis.every(x => {
                            return x.selected;
                        })
                    });
                } else {
                    return this.targetData.every((item) => {
                        return item.selected;
                    });
                }

            },
            set(newValue) {
                this.targetData.forEach((item) => {
                    item.selected = newValue;
                });
            }
        },
        nameSelection() {
            if (this.department) {
                return 'DPCR';
            }
            return 'OPCR';
        },
        officeTypeName() {
            if (this.proposal) return 'Proposal';
            return this.$store.state.data.selectedCampus.isExternal ? 'WFP' : `${this.nameSelection}`;
        },
    },
    methods: {
        toggleTreeNode(key) {
            this.$set(this.collapsedNodes, key, !this.collapsedNodes[key]);
        },
        isNodeCollapsed(key) {
            return !!this.collapsedNodes[key];
        },
        createNewOPCR() {
            this.$emit('createNewOPCR');
        },
        getAllAPI() {
            this.$emit('getAllAPI');
        },
        closeOPCRPopover() {
            this.showOPCR = false;
            this.$emit('closeOPCRPopover');
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        selectOPCR(opcr) {
            this.showOPCR = false;
            if (this.selectedOPCR && this.selectedOPCR.id == opcr.id) return;
            this.$emit('selectOPCR', opcr);
        },
        closeTargetPopOver() {
            this.showTarget = false;
            this.$emit('closeTargetPopOver');
        },
        selectIndicatorItem(indicator) {
            this.$emit('selectIndicatorItem', indicator);
        },
        filterApiCards(apis) {
            let data = apis;
            if (this.filter && this.filter.trim !== '') {
                data = data.filter(x => {
                    return x.filterKey.toUpperCase().includes(this.filter.toUpperCase());
                })
            }
            return data;
        },
        openSelectionOfApi() {
            this.$emit('openSelectionOfApi')
        },
        goToPPMP(row) {
            this.$emit('goToPPMP', row);
        },
        resubmitApi(row, parent) {
            this.$emit('resubmitApi', { row, parent });
        },
        goToPPMPAll(row, parent) {
            this.$emit('goToPPMPAll', { row, parent });
        },
        printPPMP(row) {
            this.$emit('printPPMP', row);
        },
        postOPCR(opcr) {
            this.$emit('postOPCR', opcr);
        },
        addApi(target) {
            this.$emit('addApi', target);
        },
        deleteItem(row) {
            this.$emit('deleteItem', row);
        },
        deleteItemAll(row, parent) {
            this.$emit('deleteItemAll', { row, parent });
        },
        updateItemAll(row, parent) {
            this.$emit('updateItemAll', { row, parent });
        },
        updateItem(row) {
            this.$emit('updateItem', row);
        },
        deleteOPCR(row) {
            this.$emit('deleteOPCR', row);
        },
        updateOPCR(row) {
            this.$emit('updateOPCR', row);
        },
        transferApiToOPCR() {
            this.$emit('transferApiToOPCR');
        },
        transferApiToKPI() {
            this.$emit('transferApiToKPI');
        },
        showImportApis() {
            this.$emit('showImportApis');
        },
        printDULIB() {
            this.$emit('printDULIB');
        },
        printPPMPByApi(id, type) {
            this.$emit('printPPMPByApi', { id, type });
        },
        printIndicativePR(id) {
            this.$emit('printIndicativePR', id);
        },
        printWFP() {
            this.$emit('printWFP');
        },
        printOPCR(type) {
            this.$emit('printOPCR', type);
        },
        searchDocu(row) {
            let data = row.attachments;
            if (row.fileSearch.trim() != "" && row.fileSearch) {
                data = data.filter((item) => {
                    return item.description
                        .toUpperCase()
                        .includes(row.fileSearch.toUpperCase());
                });
            }
            return data;
        },
        uploadedDocument(response, id) {
            this.$emit('uploadedDocument', { response, id })
        },
        determineApis(opcr) {
            if (this.opcrType === 'planning') {
                return opcr.planningApis;
            } else {
                return opcr.apis;
            }
        },
        transferApiIfs(row) {
            if (this.opcrType === 'planning') {
                if (this.selectedTransfer.planningApiId == row.id || this.selectedTransfer.departmentPlanningApiId == row.id) {
                    return false;
                }
                return true;
            } else {
                if (this.selectedTransfer.apiId == row.id) {
                    return false;
                }
                if ((row.status.toUpperCase() === "APPROVED" || row.status.toUpperCase() === "POSTED") && !this.$store.state.decrypt.isAdmin()) {
                    return false;
                }
                return true;
            }
        },
        viewOPCRLogs(id) {
            this.$emit('viewOPCRLogs', id);
        },
        selectTransferApi(row, parent) {
            this.$emit('selectTransferApi', { row, parent })
        },
        showApiAttachments(api) {
            this.$emit('showApiAttachments', api)
        },
        printDBM2(form, status) {
            this.$emit('printDBM2', { form, status });
        },
        printBudgetSummary() {
            this.$emit('printBudgetSummary');
        },
        printBudgetDetails() {
            this.$emit('printBudgetDetails');
        },
        canEdit(w) {
            if (this.$store.state.decrypt.isAdmin()) return true;
            let opcrNotPosted = this.selectedOPCR.status.toUpperCase().includes('DRAFT') || this.selectedOPCR.status.toUpperCase().includes('RETURN');
            if (this.proposal && opcrNotPosted && (w?.status?.toUpperCase().includes('DRAFT') || w?.status?.toUpperCase().includes('RETURN'))) return true;
            return opcrNotPosted && !this.selectedOPCR.departmentPlanningApiId && !w.departmentPlanningApiId;
        },
        canCreateApi(w) {
            if (this.$store.state.decrypt.isAdmin()) {
                return true;
            }
            if (this.opcrType != 'planning') {
                return false;
            }
            if (this.selectedOPCR) {
                if (this.proposal) {
                    if (this.selectedOPCR.status.toUpperCase().includes('DRAFT') || this.selectedOPCR.status.toUpperCase().includes('RETURN')) {
                        return true;
                    }
                } else {
                    return (this.selectedOPCR.status.toUpperCase().includes('DRAFT') || this.selectedOPCR.status.toUpperCase().includes('RETURN')) && !this.selectedOPCR.departmentPlanningApiId && !w.departmentPlanningApiId;
                }
            }
            return false;
        },
        statusColor(status) {
            switch (status.toUpperCase()) {
                case 'DRAFT':
                    return 'secondary';
                case 'RETURNED':
                    return 'warning';
                case 'POSTED':
                    return 'success';
                case 'APPROVED':
                    return 'success';
                default:
                    return 'secondary';
            }
        },
        getExportableApis(z) {
            const apis = this.filterApiCards(this.determineApis(z) || []);
            return apis.filter((w) => !w.importedToPlanningOPCR);
        },
        getSelectedApis(z) {
            return this.getExportableApis(z).filter((w) => w.selected && !w.importedToPlanningOPCR);
        },
        isAllApisSelected(z) {
            const exportable = this.getExportableApis(z);
            if (!exportable || exportable.length === 0) return false;
            return exportable.every((w) => w.selected);
        },
        toggleSelectAllApis(z, event) {
            const checked = event.target.checked;
            const exportable = this.getExportableApis(z);
            exportable.forEach((w) => {
                this.$set(w, "selected", checked);
            });
            this.$forceUpdate();
        },
        canExport(z) {
            return this.proposal && this.getExportableApis(z).length > 0 && this.selectedOPCR && !this.selectedOPCR.status.toUpperCase().includes('DRAFT')
        },
        exportApi(w) {
            if (!this.selectedOPCR || this.selectedOPCR.status.toUpperCase().includes('DRAFT')) {
                return this.showToast("OPCR is not yet posted!", "warning");
            }
            this.proceedToExport([w])
        },
        exportSelectedApis(z) {
            const selected = this.getSelectedApis(z);
            if (!selected || selected.length === 0) {
                return this.showToast("Please select at least one API to export!", "warning");
            }
            if (!this.selectedOPCR || this.selectedOPCR.status.toUpperCase().includes('DRAFT')) {
                return this.showToast("OPCR is not yet posted!", "warning");
            }
            this.proceedToExport(selected)
        },
        async proceedToExport(selected) {
            Swal.fire({
                title: "Are you sure?",
                text: selected.length == 1 ? `You want to export "${selected[0].name}" to Planning OPCR?` : `You want to export ${selected.length} selected API(s) to Planning OPCR?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, export it!",
            }).then((result) => {
                if (result.value || result.isConfirmed) {
                    ``
                    const payload = selected.map((w) => ({ id: w.id }));
                    this.exportLoading = true;
                    this.$store
                        .dispatch("planningapi/ImportToPlanningApi", payload)
                        .then((res) => {
                            this.exportLoading = false;
                            if (res && res.data && res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            selected.forEach((w) => {
                                this.$set(w, "selected", false);
                                this.$set(w, "importedToPlanningOPCR", true);
                            });
                            this.showToast("Successfully exported to Planning OPCR!", "success");
                            this.getAllAPI();
                            this.$emit("exportedApis", { apis: selected, payload });
                        })
                        .catch((err) => {
                            this.exportLoading = false;
                            const message =
                                err?.response?.data?.errorMessage ||
                                err?.response?.data?.message ||
                                "Something went wrong while exporting APIs!";
                            this.showToast(message, "error");
                        });
                }
            });
        },
        badgeClass(status) {
            if (!status) {
                return 'bg-secondary';
            }
            const s = status.toLowerCase()
            if (s.includes('draft')) return 'bg-secondary'
            else if (s.includes('post')) return 'bg-green'
            else if (s.includes('return')) return 'bg-warning'
            else if (s.includes('approve')) return 'bg-green'
            else return 'bg-secondary'
        },
        canViewBtn(opcr) {
            if (this.opcrType != 'planning') {
                return false;
            }
            if (!opcr.status || opcr.status.toLowerCase().includes('draft') || opcr.status.toLowerCase().includes('return')) {
                return true;
            }
            return false;
        }
    }
}
</script>
<template>
    <div class="d-flex">
        <div :style="{ 'width': `${sideWidth}px` }">
            <slot name="proposal-opts"></slot>

            <div v-if="canCreateOPCR" class="border-bottom pb-2 mb-2 d-flex gap-1">
                <div class="w-100 mb-1">
                    <button type="button" class="btn btn-block btn-primary" @click="createNewOPCR">
                        <i class="bx bx-plus"></i> Create New {{ officeTypeName }}
                    </button>
                </div>
                <div>
                    <b-dropdown id="dropdown-dropleft" right variant="purple" toggle-class="text-decoration-none"
                        menu-class="dropdown-menu" no-caret v-if="canCreateOPCR && !department" title="Reports">
                        <template #button-content>
                            <i class="bx bx-printer font-size-16"></i>
                        </template>
                        <template v-if="opcrType === 'planning'">
                            <template v-if="!proposal">
                                <b-dropdown-item @click="printWFP"
                                    v-if="selectedOPCR && $store.state.data.selectedCampus.isExternal">
                                    WFP
                                </b-dropdown-item>
                                <b-dropdown-item @click="printOPCR(3)"
                                    v-if="selectedOPCR && !$store.state.data.selectedCampus.isExternal">{{
                                        nameSelection
                                    }}</b-dropdown-item>
                                <b-dropdown-item @click="printOPCR(2)"
                                    v-if="selectedOPCR && !$store.state.data.selectedCampus.isExternal && $store.state.decrypt.isAdmin() && !isNGO">{{
                                        nameSelection }}
                                    (v2)</b-dropdown-item>
                                <b-dropdown-item @click="printOPCR(4)"
                                    v-if="selectedOPCR && !$store.state.data.selectedCampus.isExternal && $store.state.decrypt.isAdmin() && !isNGO">{{
                                        nameSelection }}
                                    (v3)</b-dropdown-item>
                                <b-dropdown-item @click="printDULIB" v-if="selectedOPCR">LIB</b-dropdown-item>
                                <!-- <b-dropdown-item v-if="selectedOPCR" @click="printPPMP(1)">PPMP</b-dropdown-item> -->
                                <b-dropdown-item v-if="selectedOPCR" @click="printPPMP(2)">
                                    PPMP
                                    <!-- (v2) -->
                                </b-dropdown-item>
                            </template>
                            <template v-else>
                                <!-- <hr> -->
                                <!-- <b-dropdown-item v-if="selectedOPCR" @click="printDBM2(1, 'Draft')">DBM Form 2 Tier 1
                                    Draft</b-dropdown-item>
                                <b-dropdown-item v-if="selectedOPCR" @click="printDBM2(1, 'Approved')">DBM Form 2 Tier 1
                                    Approved</b-dropdown-item>
                                <b-dropdown-item v-if="selectedOPCR" @click="printDBM2(2, 'Draft')">DBM Form 2 Tier 2
                                    Draft</b-dropdown-item>
                                <b-dropdown-item v-if="selectedOPCR" @click="printDBM2(2, 'Approved')">DBM Form 2 Tier 2
                                    Approved</b-dropdown-item> -->
                                <b-dropdown-item v-if="selectedOPCR" @click="printBudgetDetails">
                                    Budget Details</b-dropdown-item>
                                <b-dropdown-item v-if="selectedOPCR" @click="printBudgetSummary">
                                    Budget Summary</b-dropdown-item>
                            </template>
                        </template>
                        <template v-else>
                            <b-dropdown-item @click="printOPCR" v-if="!$store.state.data.selectedCampus.isExternal">{{
                                nameSelection }}</b-dropdown-item>
                            <b-dropdown-item @click="printWFP"
                                v-if="$store.state.data.selectedCampus.isExternal">WFP</b-dropdown-item>
                            <b-dropdown-item @click="printDULIB">LIB</b-dropdown-item>
                            <b-dropdown-item @click="printPPMP">PPMP</b-dropdown-item>
                            <b-dropdown-item v-if="selectedOPCR" @click="printPPMP(2)">PPMP (v2)</b-dropdown-item>
                        </template>
                    </b-dropdown>
                </div>
            </div>
            <div v-else class="d-flex justify-content-end border-bottom pb-2 mb-2">

                <b-dropdown id="dropdown-dropleft" right variant="purple btn-sm" toggle-class="text-decoration-none"
                    menu-class="dropdown-menu" no-caret v-if="opcrType == 'actual' && !department">
                    <template #button-content>
                        <i class="bx bx-printer me-1"></i>
                        Reports
                    </template>
                    <b-dropdown-item @click="printOPCR" v-if="!$store.state.data.selectedCampus.isExternal">{{
                        nameSelection
                    }}</b-dropdown-item>
                    <b-dropdown-item @click="printOPCR(4)"
                        v-if="!$store.state.data.selectedCampus.isExternal && $store.state.decrypt.isAdmin() && !isNGO">{{
                            nameSelection
                        }}
                        (v3)</b-dropdown-item>
                    <b-dropdown-item @click="printWFP"
                        v-if="$store.state.data.selectedCampus.isExternal">WFP</b-dropdown-item>
                    <b-dropdown-item @click="printDULIB">LIB</b-dropdown-item>
                    <b-dropdown-item @click="printPPMP">PPMP</b-dropdown-item>
                    <b-dropdown-item v-if="selectedOPCR" @click="printPPMP(2)">PPMP (v2)</b-dropdown-item>
                </b-dropdown>
            </div>
            <div v-if="loadOpcrs">
                <div class="text-center">
                    <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
            <template v-if="!loadOpcrs && opcrs.length == 0">
                <div class="text-center py-5">
                    No {{ officeTypeName }} found...
                </div>
            </template>
            <template v-if="!loadOpcrs && opcrs.length">
                <div class="pb-2 mb-2 border-bottom">
                    <b-form-input v-model="searchOPCR" placeholder="Search OPCR..."></b-form-input>
                </div>
                <template v-if="!filteredOPCRs.length">
                    <div class="text-center">
                        Search not found...
                    </div>
                </template>
                <div v-else>
                    <ul class="opcr-list">
                        <li v-for="opcr in filteredOPCRs" :key="opcr.id"
                            :class="{ 'active': selectedOPCR && selectedOPCR.id == opcr.id, 'stayPV': opcr.showPV }"
                            @click="selectOPCR(opcr)">
                            <div class="position-relative">
                                <RawData :data="opcr" v-if="$store.state.decrypt.isAdmin()" />
                                <p class="mb-0">{{ opcr.title }} <sup><span class="badge rounded-pill font-size-10"
                                            :class="badgeClass(opcr.status)">{{
                                                opcr.status }}</span></sup></p>
                                <small class="text-green" v-if="opcr.isSupplemental">Supplemental</small>
                                <div class="position-absolute opcr-actions"
                                    :style="{ 'top': '50%', 'right': '5px', transform: 'translateY(-50%)' }">
                                    <button class="opcr-btn" @click.stop :id="`opcr-${opcr.id}`"><i
                                            class="fa fa-ellipsis-h"></i></button>
                                    <b-popover :target="`opcr-${opcr.id}`" triggers="click blur"
                                        custom-class="opcr-popover" :show.sync="opcr.showPV">
                                        <b-list-group class="w-100 fit">
                                            <b-list-group-item button action @click.stop="postOPCR(opcr)"
                                                class="text-green" v-if="canViewBtn(opcr)">
                                                <i class="bx bx-check align-middle me-2"></i><span
                                                    class="align-middle">Post</span>
                                            </b-list-group-item>
                                            <b-list-group-item button action @click.stop="viewOPCRLogs(opcr.id)"
                                                v-if="opcrType === 'planning' && !department && selectedOPCR">
                                                <i class="bx bx-receipt align-middle me-2"></i><span
                                                    class="align-middle">View
                                                    Logs</span>
                                            </b-list-group-item>
                                            <b-list-group-item button action @click.stop="updateOPCR(opcr)"
                                                v-if="canViewBtn(opcr)">
                                                <i class="bx bx-edit align-middle me-2"></i><span
                                                    class="align-middle">Edit</span>
                                            </b-list-group-item>
                                            <b-list-group-item button action @click.stop="deleteOPCR(opcr)"
                                                v-if="canViewBtn(opcr)" class="text-danger">
                                                <i class="bx bx-trash align-middle me-2"></i><span
                                                    class="align-middle">Delete</span>
                                            </b-list-group-item>
                                        </b-list-group>
                                    </b-popover>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </template>
        </div>
        <div :style="{ 'width': `calc(100% - ${sideWidth}px)`, 'padding': '0 20px 0' }" class="border-left">
            <slot name="proposal-deadline"></slot>
            <div class="card border shadow">
                <div class="card-body">
                    <div class="
                            d-flex
                            justify-content-between
                            align-items-center
                        ">
                        <h4 class="card-title m-0">
                            {{ apiName }} API List
                        </h4>
                        <template v-if="opcrType === 'planning'">
                            <button v-if="
                                selectedOPCR &&
                                !selectAllAPI &&
                                selectedItem > 0 &&
                                !selectedTransfer.id
                                && !startSelection
                                && (selectedOPCR && (selectedOPCR.status.toUpperCase().includes('DRAFT') || selectedOPCR.status.toUpperCase().includes('RETURN')))
                            " type="button" @click="addApi(null)" class="
                                    btn btn-md btn-info
                                    d-flex
                                    align-items-center
                                    no-wrap
                                ">
                                <i class="bx bx-plus fs-6"></i>Create New
                            </button>
                            <button v-if="
                                !department &&
                                selectedItem == 0 &&
                                selectAllAPI &&
                                !proposal &&
                                !selectedTransfer.id
                                && !startSelection
                                && (selectedOPCR && (selectedOPCR.status.toUpperCase().includes('DRAFT') || selectedOPCR.status.toUpperCase().includes('RETURN')))
                            " type="button" @click="showImportApis()" class="
                                    btn btn-md btn-info
                                    d-flex
                                    align-items-center
                                    no-wrap
                                ">
                                <i class="bx bx-download fs-6 me-1"></i>Department API's
                            </button>
                        </template>
                        <template v-else>
                            <button type="button" @click="addApi(null)"
                                v-if="selectedOPCR && $store.state.decrypt.isAdmin() && !selectedTransfer.id && !selectAllAPI"
                                class="
                                    btn btn-md btn-info
                                    d-flex
                                    align-items-center
                                    no-wrap
                                ">
                                <i class="bx bx-plus fs-6"></i>Create New
                            </button>
                        </template>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-6">
                            <div id="tickets-table_length" class="dataTables_length">
                                <label class="
                                        d-inline-flex
                                        align-items-center
                                        mb-0
                                    ">
                                    Show&nbsp;
                                    <b-form-select class="
                                            form-select
                                            form-select-sm
                                            mx-1
                                        " v-model="perPage" size="sm" :options="pageOptions
                                            "></b-form-select>&nbsp;entries
                                </label>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div id="tickets-table_filter" class="
                                    dataTables_filter
                                    text-md-end
                                ">
                                <label class="
                                        d-inline-flex
                                        align-items-center
                                    ">
                                    Search:
                                    <b-form-input autocomplete="off" v-model="filter" type="search"
                                        placeholder="Search..." class="
                                            form-control
                                            form-control-sm
                                            ms-2
                                        "></b-form-input>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="mt-2">
                        <template v-if="tableBusy">
                            <div class="d-flex justify-content-center align-items-center">
                                <div class="spinner-grow text-primary" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div v-if="filteredApis.length === 0" class="text-center text-muted border-top border-2">
                                <h5 class="py-5 my-5"><i class="bx bx-error-circle"></i> No data found</h5>
                            </div>
                            <template v-else>
                                <b-tabs nav-class="nav-tabs-custom" content-class="pt-0 px-2 text-muted">
                                    <b-tab v-for="x in filteredApis" :key="x.id">
                                        <template v-slot:title>
                                            {{ x.key }}
                                        </template>
                                        <div v-for="(p, pIndex) in x.data" :key="`${x.id}P-${pIndex}`" class="mt-2">
                                            <hr v-if="pIndex != 0" class="py-0 my-1">
                                            <div class="opcr-tree">
                                                <div
                                                    class="tree-root-header d-flex align-items-center justify-content-between px-2 rounded">
                                                    <div class="d-flex align-items-center">
                                                        <span class="font-size-15 fw-bold text-body cursor-pointer">{{
                                                            p.prexc
                                                            }}</span>
                                                        <!-- @click="toggleTreeNode(`${x.id}P-${pIndex}`)" -->
                                                    </div>
                                                </div>
                                                <div v-show="!isNodeCollapsed(`${x.id}P-${pIndex}`)"
                                                    class="tree-children tree-indicator-children">
                                                    <div v-for="(i, iIndex) in p.data"
                                                        :key="`${x.id}P-${pIndex}I-${iIndex}`"
                                                        class="tree-node tree-indicator-node">
                                                        <div
                                                            class="tree-node-content tree-indicator-header d-flex align-items-center justify-content-between cursor-pointer">
                                                            <div class="d-flex align-items-center">
                                                                <span class="font-size-14 fw-semibold text-body">{{
                                                                    i.indicator }}</span>
                                                            </div>
                                                            <!-- @click="toggleTreeNode(`${x.id}P-${pIndex}I-${iIndex}`)" -->
                                                        </div>
                                                        <div v-show="!isNodeCollapsed(`${x.id}P-${pIndex}I-${iIndex}`)"
                                                            class="tree-children tree-kpi-children">
                                                            <div v-for="(k, kIndex) in i.data"
                                                                :key="`${x.id}P-${pIndex}I-${iIndex}K-${kIndex}`"
                                                                class="tree-node tree-kpi-node mb-2">
                                                                <div
                                                                    class="tree-node-content tree-kpi-header d-flex align-items-center justify-content-between cursor-pointer">
                                                                    <div class="d-flex align-items-center">
                                                                        <span
                                                                            class="font-size-13 fw-medium text-body">{{
                                                                                k.indicatorItem
                                                                            }}</span>
                                                                    </div>
                                                                    <!-- @click="toggleTreeNode(`${x.id}P-${pIndex}I-${iIndex}K-${kIndex}`)" -->
                                                                </div>
                                                                <div v-show="!isNodeCollapsed(`${x.id}P-${pIndex}I-${iIndex}K-${kIndex}`)"
                                                                    class="tree-children tree-target-children">
                                                                    <div v-for="(z, zIndex) in k.data"
                                                                        :key="`${x.id}P-${pIndex}I-${iIndex}K-${kIndex}Z-${zIndex}`"
                                                                        class="tree-node tree-target-node mb-2">
                                                                        <div class="tree-target-card px-3 py-2"
                                                                            :class="{ 'is-open': z.showApis }">
                                                                            <div
                                                                                class="d-flex justify-content-between align-items-center">
                                                                                <div
                                                                                    class="d-flex align-items-center flex-wrap">
                                                                                    <span
                                                                                        class="font-size-14 text-yellow text-hover cursor-pointer fw-medium"
                                                                                        @click="z.showApis = !z.showApis">{{
                                                                                            opcrType
                                                                                                === 'planning'
                                                                                                ? z.planningTarget : z.target
                                                                                        }}</span>
                                                                                    <span
                                                                                        class="badge bg-soft-info text-info cursor-pointer font-size-11"
                                                                                        @click="z.showApis = !z.showApis">
                                                                                        <i
                                                                                            class="bx bx-layer me-1"></i>{{
                                                                                                determineApis(z).length }} API{{
                                                                                            determineApis(z).length
                                                                                                === 1 ? '' : 's' }}
                                                                                    </span>
                                                                                </div>
                                                                                <div v-if="canCreateApi(z)"
                                                                                    :style="{ width: '140px' }"
                                                                                    class="d-flex justify-content-end ms-3">
                                                                                    <button type="button"
                                                                                        class="btn btn-sm btn-info"
                                                                                        @click="addApi(z)"
                                                                                        v-if="!selectedTransfer.id">
                                                                                        <i
                                                                                            class="bx bx-plus me-1"></i>Create
                                                                                        API
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                            <template v-if="z.showApis">
                                                                                <hr class="mt-2 mb-2">
                                                                                <div
                                                                                    class="d-flex justify-content-between align-items-center mb-2 px-1">
                                                                                    <div
                                                                                        class="d-flex align-items-center">
                                                                                        <div class="form-check form-checkbox-outline form-check-success me-2"
                                                                                            v-if="canExport(z)">
                                                                                            <input type="checkbox"
                                                                                                :id="`selectAllApi-${x.id}-${zIndex}`"
                                                                                                class="form-check-input"
                                                                                                :checked="isAllApisSelected(z)"
                                                                                                @change="toggleSelectAllApis(z, $event)" />
                                                                                        </div>
                                                                                        <h6 no-body
                                                                                            class="mb-0 fw-semibold text-body">
                                                                                            {{ x.data.length ?
                                                                                                `List of API's` :
                                                                                                'No data found' }}
                                                                                        </h6>
                                                                                    </div>
                                                                                    <div
                                                                                        v-if="proposal && getSelectedApis(z).length">
                                                                                        <button type="button"
                                                                                            class="btn btn-sm btn-success"
                                                                                            :disabled="exportLoading"
                                                                                            @click="exportSelectedApis(z)">
                                                                                            <i class="bx bx-export me-1"
                                                                                                v-if="!exportLoading"></i>
                                                                                            <span
                                                                                                class="spinner-border spinner-border-sm me-1"
                                                                                                role="status"
                                                                                                aria-hidden="true"
                                                                                                v-else></span>
                                                                                            Export Selected ({{
                                                                                                getSelectedApis(z).length
                                                                                            }}) APIs
                                                                                            to Planning OPCR
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                                <div class="mt-2">
                                                                                    <div v-for="w in filterApiCards(determineApis(z))"
                                                                                        :key="`API-B-${w.id}`"
                                                                                        class="tree-node tree-api-node mb-2">
                                                                                        <b-card no-body
                                                                                            class="mb-0 shadow-none border tree-api-card">
                                                                                            <RawData
                                                                                                v-if="$store.state.decrypt.isAdmin()"
                                                                                                :data="w" />
                                                                                            <b-card-header>
                                                                                                <div
                                                                                                    class="d-flex justify-content-between align-items-center">
                                                                                                    <div>
                                                                                                        <template
                                                                                                            v-if="!startSelection">
                                                                                                            <div
                                                                                                                class="d-flex">
                                                                                                                <div class="form-check form-checkbox-outline form-check-success"
                                                                                                                    v-if="proposal && !w.importedToPlanningOPCR && selectedOPCR && !selectedOPCR.status.toUpperCase().includes('DRAFT')">
                                                                                                                    <input
                                                                                                                        type="checkbox"
                                                                                                                        :id="`apiSelection-${w.id}`"
                                                                                                                        checked="checked"
                                                                                                                        class="form-check-input"
                                                                                                                        v-model="w.selected"
                                                                                                                        @change="$forceUpdate()" />
                                                                                                                </div>
                                                                                                                <span
                                                                                                                    class="d-block cursor-pointer text-hover"
                                                                                                                    @click="goToPPMPAll(w, z)"><span
                                                                                                                        class="text-warning">[{{
                                                                                                                            w.id
                                                                                                                        }}]</span>{{
                                                                                                                            w.name
                                                                                                                        }}
                                                                                                                    <span
                                                                                                                        v-if="w.fromModification"
                                                                                                                        class="font-size-10 text-green">[From
                                                                                                                        Modification]</span>
                                                                                                                    <sup v-if="w.departmentName"
                                                                                                                        class="badge bg-purple">{{
                                                                                                                            w.departmentName
                                                                                                                        }}</sup>
                                                                                                                    <sup v-if="proposal && w.status"
                                                                                                                        class="badge"
                                                                                                                        :class="[`bg-${statusColor(w.status)}`]">{{
                                                                                                                            w.status
                                                                                                                        }}</sup>
                                                                                                                    <sup v-if="proposal && w.tier"
                                                                                                                        class="badge ms-1"
                                                                                                                        :class="[`bg-purple`]">{{
                                                                                                                            w.tier
                                                                                                                        }}</sup>
                                                                                                                </span>
                                                                                                            </div>
                                                                                                        </template>
                                                                                                        <template
                                                                                                            v-else>
                                                                                                            <div class="
                                                                                                                    form-check
                                                                                                                    form-checkbox-outline
                                                                                                                    form-check-success
                                                                                                                ">
                                                                                                                <input
                                                                                                                    type="checkbox"
                                                                                                                    :id="`apiSelection-${w.id}`"
                                                                                                                    checked="checked"
                                                                                                                    class="form-check-input"
                                                                                                                    v-model="w.selected" /><label
                                                                                                                    :for="`apiSelection-${w.id}`"
                                                                                                                    class="form-check-label">
                                                                                                                    <b class="text-white"
                                                                                                                        :id="`${w.id}`">
                                                                                                                        [{{
                                                                                                                            w.id
                                                                                                                        }}]{{
                                                                                                                            w.name
                                                                                                                        }}
                                                                                                                    </b>
                                                                                                                </label>
                                                                                                            </div>
                                                                                                        </template>
                                                                                                        <small
                                                                                                            class="d-block"
                                                                                                            v-if="w.description">[{{
                                                                                                                w.description
                                                                                                            }}]</small>
                                                                                                        <small>Total: {{
                                                                                                            w.totalResources
                                                                                                        }}</small>
                                                                                                        <small
                                                                                                            v-if="w.isBigProject || proposal"
                                                                                                            class="d-block"><a
                                                                                                                href="javascript:void(0)"
                                                                                                                class="text-yellow"
                                                                                                                @click="showApiAttachments(w)">[Attachments]</a></small>
                                                                                                    </div>
                                                                                                    <b-dropdown
                                                                                                        id="dropdown-dropleft"
                                                                                                        right
                                                                                                        variant="link"
                                                                                                        toggle-class="text-decoration-none"
                                                                                                        menu-class="dropdown-menu-end"
                                                                                                        no-caret
                                                                                                        v-if="!selectedTransfer.id">
                                                                                                        <template
                                                                                                            #button-content><i
                                                                                                                class="fas fa-ellipsis-v"></i></template>
                                                                                                        <b-dropdown-item
                                                                                                            @click="goToPPMPAll(w, z)"
                                                                                                            variant="dark">
                                                                                                            <i
                                                                                                                class="bx bx-notepad font-size-18 me-1"></i>Resources
                                                                                                        </b-dropdown-item>
                                                                                                        <template
                                                                                                            v-if="opcrType === 'planning'">
                                                                                                            <b-dropdown-item
                                                                                                                @click="resubmitApi(w)"
                                                                                                                variant="success"
                                                                                                                v-if="w.status && w.status.toUpperCase().includes('RETURN')">
                                                                                                                <i
                                                                                                                    class="bx bx-check font-size-18 me-1"></i>
                                                                                                                Resubmit
                                                                                                                API
                                                                                                            </b-dropdown-item>
                                                                                                            <b-dropdown-item
                                                                                                                @click="printPPMPByApi(w.id, 1)"
                                                                                                                variant="purple"
                                                                                                                v-if="!department">
                                                                                                                <i
                                                                                                                    class="bx bx-printer font-size-18 me-1"></i>Generate
                                                                                                                PPMP
                                                                                                            </b-dropdown-item>
                                                                                                            <b-dropdown-item
                                                                                                                @click="printPPMPByApi(w.id, 2)"
                                                                                                                variant="purple"
                                                                                                                v-if="!department">
                                                                                                                <i
                                                                                                                    class="bx bx-printer font-size-18 me-1"></i>Generate
                                                                                                                PPMP
                                                                                                                (v2)
                                                                                                            </b-dropdown-item>
                                                                                                            <!-- <b-dropdown-item
                                                                                                                @click="printIndicativePR(w.id)"
                                                                                                                variant="purple"
                                                                                                                v-if="!department"
                                                                                                            >
                                                                                                                <i class="bx bx-printer font-size-18 me-1"></i>Generate Indicative PR
                                                                                                            </b-dropdown-item> -->
                                                                                                            <b-dropdown-item
                                                                                                                v-if="canEdit(w)"
                                                                                                                @click="updateItemAll(w, z)"
                                                                                                                variant="dark">
                                                                                                                <i
                                                                                                                    class="bx bx-edit font-size-18 me-1"></i>Edit</b-dropdown-item>
                                                                                                            <b-dropdown-item
                                                                                                                v-if="canEdit(w)"
                                                                                                                @click="deleteItemAll(w, z)"
                                                                                                                variant="danger">
                                                                                                                <i
                                                                                                                    class="mdi mdi-trash-can font-size-18 me-1"></i>Delete</b-dropdown-item>
                                                                                                            <b-dropdown-item
                                                                                                                @click="$emit('show-logs', w)"
                                                                                                                variant="dark">
                                                                                                                <i
                                                                                                                    class="bx bx-receipt font-size-18 me-1"></i>Show
                                                                                                                Logs
                                                                                                            </b-dropdown-item>
                                                                                                            <b-dropdown-item
                                                                                                                @click="exportApi(w)"
                                                                                                                variant="success"
                                                                                                                v-if="proposal && !w.importedToPlanningOPCR">
                                                                                                                <i
                                                                                                                    class="bx bx-upload font-size-18 me-1"></i>Export
                                                                                                                to
                                                                                                                Planning
                                                                                                                OPCR
                                                                                                            </b-dropdown-item>
                                                                                                        </template>
                                                                                                        <template
                                                                                                            v-else>
                                                                                                            <b-dropdown-item
                                                                                                                @click="printPPMPByApi(w.id, 1)"
                                                                                                                v-if="w.status && w.status.toLowerCase() === 'posted'"
                                                                                                                variant="purple">
                                                                                                                <i
                                                                                                                    class="bx bx-printer font-size-18 me-1"></i>Generate
                                                                                                                PPMP
                                                                                                            </b-dropdown-item>
                                                                                                            <b-dropdown-item
                                                                                                                @click="printPPMPByApi(w.id, 2)"
                                                                                                                variant="purple"
                                                                                                                v-if="!department">
                                                                                                                <i
                                                                                                                    class="bx bx-printer font-size-18 me-1"></i>Generate
                                                                                                                PPMP
                                                                                                                (v2)
                                                                                                            </b-dropdown-item>
                                                                                                            <b-dropdown-item
                                                                                                                @click="updateItemAll(w, z)"
                                                                                                                variant="dark"
                                                                                                                v-if="$store.state.decrypt.isAdmin()">
                                                                                                                <i
                                                                                                                    class="bx bx-edit font-size-18 me-1"></i>Edit
                                                                                                            </b-dropdown-item>
                                                                                                            <b-dropdown-item
                                                                                                                v-if="$store.state.decrypt.isAdmin()"
                                                                                                                @click="deleteItemAll(w, z)"
                                                                                                                variant="danger">
                                                                                                                <i
                                                                                                                    class="mdi mdi-trash-can font-size-18 me-1"></i>Delete</b-dropdown-item>
                                                                                                        </template>
                                                                                                    </b-dropdown>
                                                                                                    <div v-else
                                                                                                        class="text-center">
                                                                                                        <small
                                                                                                            v-if="transferApiIfs(w)"><a
                                                                                                                href="javascript:void(0);"
                                                                                                                class="text-success hoverable-link text-nowrap"
                                                                                                                @click="selectTransferApi(w, z)">Transfer
                                                                                                                Here</a></small>
                                                                                                        <small v-else
                                                                                                            class="text-muted">Can't
                                                                                                            transfer
                                                                                                            here</small>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </b-card-header>
                                                                                        </b-card>
                                                                                    </div>
                                                                                </div>
                                                                            </template>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </b-tab>
                                </b-tabs>
                            </template>
                        </template>
                        <hr>
                    </div>
                    <div class="row">
                        <template v-if="opcrType === 'planning'">
                            <div class="col"
                                v-if="!selectAllAPI && selectedOPCR && targetData.length && selectedOPCR.status.toUpperCase() === 'DRAFT'">
                                <div class="d-flex align-items-center">
                                    <button type="button" class="btn btn-link"
                                        :class="{ 'text-warning': startSelection }" @click="openSelectionOfApi">
                                        <span v-if="!startSelection" class="d-flex align-items-center"><i
                                                class="bx bx-repost"></i>Transfer API to another Target</span>
                                        <span v-else class="d-flex align-items-center"><i class="bx bx-x"></i>Cancel
                                            Transfer</span>
                                    </button>
                                    <div class="d-flex align-items-center" v-if="startSelection">
                                        <span class="me-2">[ {{ selectedApiComputed.length }} selected ]</span>
                                        <button type="button" class="btn btn-success btn-sm"
                                            v-if="selectedApiComputed.length > 0" @click="transferApiToKPI"><i
                                                class="bx bx-check"></i> Transfer Now</button>
                                    </div>
                                </div>
                            </div>
                            <div class="col"
                                v-if="selectAllAPI && !proposal && selectedOPCR && targetData.length && $store.state.decrypt.isAdmin() && !tableBusy">
                                <div class="d-flex align-items-center">
                                    <button type="button" class="btn btn-link"
                                        :class="{ 'text-warning': startSelection }" @click="openSelectionOfApi">
                                        <span v-if="!startSelection" class="d-flex align-items-center"><i
                                                class="bx bx-repost"></i>Transfer API to another
                                            {{ nameSelection }}</span>
                                        <span v-else class="d-flex align-items-center"><i class="bx bx-x"></i>Cancel
                                            Transfer</span>
                                    </button>
                                    <div class="d-flex align-items-center" v-if="startSelection">
                                        <span class="me-2">[ {{ selectedApiComputed.length }} selected ]</span>
                                        <button type="button" class="btn btn-success btn-sm"
                                            v-if="selectedApiComputed.length > 0" @click="transferApiToOPCR"><i
                                                class="bx bx-check"></i> Transfer Now</button>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <div class="col" v-if="!selectAllAPI">
                            <div class="
                                    dataTables_paginate
                                    paging_simple_numbers
                                    float-end
                                ">
                                <ul class="
                                        pagination
                                        pagination-rounded
                                        mb-0
                                    ">
                                    <!-- pagination -->
                                    <b-pagination v-model="currentPage
                                        " :total-rows="rows" :per-page="perPage"></b-pagination>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
.opcr-actions {
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.15s ease-in-out, visibility 0.15s ease-in-out;
}

.opcr-list li:hover .opcr-actions,
.opcr-list li.stayPV .opcr-actions {
    opacity: 1;
    visibility: visible;
}

.opcr-btn {
    border: none !important;
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.25);
    height: 25px;
    width: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--bs-white);
}

.opcr-list {
    padding: 0;
    margin: 0;
    list-style: none;
    overflow: hidden;
    overflow-y: auto;
}

.opcr-list li {
    padding: 10px;
    font-size: 14px;
    cursor: pointer;
    margin-bottom: 2px;
}

.opcr-list li:hover {
    color: var(--bs-info) !important;
    background-color: rgba(var(--bs-info-rgb), 0.15);
}

.opcr-list li.active {
    border-left: 4px solid var(--bs-info);
    color: var(--bs-info) !important;
    font-weight: bold;
    background-color: rgba(var(--bs-info-rgb), 0.15);
}

/* OPCR Tree View Styles */
.opcr-tree {
    position: relative;
}

.tree-root-header {
    padding: 3px 5px;
}

.tree-children {
    position: relative;
    margin-left: 18px;
    padding-left: 12px;
}

.tree-node {
    position: relative;
}

/* Vertical guide line running down child branch */
.tree-children>.tree-node::before {
    content: "";
    position: absolute;
    top: -4px;
    left: -14px;
    bottom: -8px;
    width: 2px;
    background-color: rgba(120, 140, 175, 0.3);
    pointer-events: none;
}

/* Horizontal arm pointing into node */
.tree-children>.tree-node::after {
    content: "";
    position: absolute;
    top: 10px;
    left: -14px;
    width: 14px;
    height: 2px;
    background-color: rgba(120, 140, 175, 0.3);
    pointer-events: none;
}

/* Last child stops vertical guide line at the horizontal arm */
.tree-children>.tree-node:last-child::before {
    height: 15px;
    bottom: auto;
}

/* Indicator Node */
.tree-indicator-header {
    padding: 3px 5px;
}

/* KPI Node */
.tree-kpi-header {
    padding: 3px 5px;
}

/* Target Node Card */
.tree-target-card {
    border: 1px solid rgba(52, 195, 143, 0.25);
    border-radius: 6px;
    transition: all 0.2s ease;
}

/* API Card in Tree */
.tree-api-card {
    position: relative;
    border-radius: 6px;
    transition: all 0.2s ease;
}

.tree-api-card:hover,
.tree-api-card:focus-within {
    z-index: 5;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.tree-toggle-btn {
    border: none;
    background: transparent;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
}

.tree-toggle-btn:focus {
    outline: none;
    box-shadow: none;
}

.opcr-popover .popover-body {
    max-width: 250px;
    padding: 0 !important;
    border: 1px solid var(--bs-border)
}
</style>